import { Component, Input } from '@angular/core';

import { DynamicModule } from 'ng-dynamic-component';

import { Components } from '@valk-nx/storyblok/components/reference/src/lib/reference.component';
import { StoryblokRootDirective } from '@valk-nx/storyblok-directives/src/lib/directives/storyblok-root.directive';

@Component({
	selector: 'sb-page',
	templateUrl: './page.component.html',
	imports: [DynamicModule],
})
export class PageComponent extends StoryblokRootDirective {
	components: typeof Components = Components;

	@Input({ required: true }) content!: unknown[];

	@Input({ required: true }) metaDescription!: string;
	@Input({ required: true }) metaTitle!: string;
}
